import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { BaseComponent } from '../base.component';

@Directive({
    selector: '[addIntercomDataAttribute]',
    standalone: true
})
export class AddIntercomDataAttributeDirective extends BaseComponent {
    private width: number;
    private key: string;
    private isMobile: boolean;
    private isDesktop: boolean;
    static MAX_WIDTH = 900;

    @Input() set addIntercomDataAttribute(event: { key: string, isMobile: boolean, isDesktop: boolean }) {
        this.key = event.key;
        this.isMobile = event.isMobile;
        this.isDesktop = event.isDesktop;
        this.onResize();
        this.checkHideIntercomAttribute();
    }

    @HostListener('window:resize')
    onResize() {
        this.width = window.innerWidth;
        this.checkHideIntercomAttribute();
    }

    constructor(private element: ElementRef,
                private renderer: Renderer2) {
        super();
    }

    private checkHideIntercomAttribute() {
        if (!this.isDesktop || !this.isMobile) {
            if (this.isDesktop && this.width <= AddIntercomDataAttributeDirective.MAX_WIDTH) {
                this.renderer.setAttribute(this.element.nativeElement, 'data-intercom-target', '');
                return;
            }

            if (this.isMobile && this.width > AddIntercomDataAttributeDirective.MAX_WIDTH) {
                this.renderer.setAttribute(this.element.nativeElement, 'data-intercom-target', '');
                return;
            }
        }

        this.renderer.setAttribute(this.element.nativeElement, 'data-intercom-target', this.key);
    }
}
